module.exports = __webpack_public_path__ + "static/social-media-app-cover-631a5895eeb8fe3fa16b863445e5a6f0.png";